import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/shared/lib/rback/AuthContext";

interface IPermissionRouteProps {
  requiredpermissions: string | string[];
  children: ReactNode;
}

export const PermissionRoute = ({
  requiredpermissions,
  children,
}: IPermissionRouteProps) => {
  const { hasPermission } = useAuth();

  if (!hasPermission(requiredpermissions)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};
